// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

// This file is used as a shim of "FileDownloadResponse" for some browser bundlers
// when trying to bundle "FileDownloadResponse"
// "FileDownloadResponse" class is only available in Node.js runtime
export const FileDownloadResponse = 1;
